<div class="component-wrapper">
  <div class="content-wrapper">
    <main>
      <h1>Logistische Regression</h1>
      Die <b>logistische Regression </b>, oder auch die BLR (Binary Logistic Regression) basiert auf den Prinzipien der
      linearen Regression (s. multiple lineare Regression). Die Besonderheit ist, und das macht sie in der Praxis so
      beliebt, dass die abhängige Variable nominal mit zwei Ausprägungen ist. Sie bildet die Realität häufig besser ab
      als eine ein lineares Modell, da sie Aussagen über die Chance für das Auftreten eines bestimmten Ereignisses
      treffen kann (Odds Ratio oder auch Quotenverhältnis). Zudem besitzt die BLR beinahe keine Voraussetzungen (vgl.
      >10 bei der linearen Regression). <br><br>

      <p>Hier eine Erklärung auf
        YouTube</p>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/6b6-QNoMXik" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>

      <h2>Typ und Anwendung </h2>
      <b>Zusammenhangsanalyse</b> Gibt es einen Zusammenhang zwischen zwei oder mehreren Variablen? Wie ändert sich
      die Chance für die Ausprägung der abhängigen Variable (Y=1), wenn die Variablen X1, X2,… um jeweils eine
      Einheit steigen? Die BLR kann dabei als eine Modifikation der linearen Regression gesehen werden. Die
      lineare Funktion wird dabei als sogenannte Linkfunktion benutzt. Für unser Beispiel aus der linearen
      Regression (vorhersage der Klausurleistung) ergibt sich
      Lineare Funktionsgleichung:
      <div class="center">
        Klausurleistung = Intercept(17.3724) + 3.1493 * Lernstunden - 1.8552 * Versuch - 3.0369 * Geschlecht +
        Messfehler(E)
      </div>
      Logistische Funktionsgleichung: <br><br>
      <img src="../../../assets/img/log_gleichung_1.jpg" alt="logistische funktionsgleichung 1"> <br> <br>

      <b>Bestanden</b> ist unsere abhängige Variable die die Ausprägungen 0 (nicht bestanden) und 1 (bestanden)
      annehmen kann
      <b>e</b> Eulersche Zahl, eine Konstante mit dem Wert 2.71828(…)

      <h2>Beispiele </h2><br><br>
      Wie ändert sich die Chance zum Kauf eines Produktes (Y=1 ist Kauf, Y=0 ist nicht Kauf), wenn
      das Budget um 1000€ steigt? Und welchen Einfluss spielt das Geschlecht dabei (Dummy codiert,
      männlich=0, weiblich=1). Hierbei handelt es sich um eine multiple BLR, wenn mehrere
      unabhängige Variablen in der Gleichung sind. An dieser Stelle zeigt sich der praktische
      Vorteile der BLR. Während man mit einer linearen Funktion die Tendenz zum Kauf eines
      Produktes erst einmal operationalisieren müsste (metrisches Skalenniveau, z.B. eine Likert
      Skale 1-5) kann man in der BLT Hard Facts benutzen: gekauft vs. nicht gekauft.
      Ein weiteres Beispiel: wie ändert sich die Chance an Corona zu erkranken (Y=1), wenn das
      Alter um ein Jahr steigt, das Geschlecht männlich ist und die Anzahl der Einkäufe/ Woche um
      eine Einheit steigt? <br><br>




      <h2>Voraussetzungen </h2>
      <ul>
        <li>Die UVs müssen metrisch oder Dummy codiert sein (0-1) </li>
        <li>Die AV muss nominal sein und zwei Ausprägungen haben (binär, 0-1) </li>
        <li>In jeder unabhängigen Dummy Variable braucht man pro Gruppe &gt;=25 Beobachtungen
        </li>
        <li>Die unabhängigen Variablen sind nicht hoch korreliert (Keine Multikollinearität)
        </li>
      </ul>
      <br>
          <h2>Beispiel SPSS    </h2>
      Gegeben sei ein einfacher Datensatz (s. lineare Regression). 64 Studierende wurden
      hinsichtlich ihrer Statistikklausur befragt. Die Angabe erfolgte dabei in Prozent
      (Eine Schulnote stellt ein ordinales Skalenniveau dar und kann an dieser Stelle
      nicht verwendet werden!). Als unabhängige Variablen, die die Leistung beeinflusst
      haben, vermuten wir die gelernten Stunden, der Klausurversuch und das Geschlecht.
      Dazu wurde das Outcome in Prozent nun in eine binäre Variable transformiert
      (bestanden vs. nicht bestanden). <br>

      <img src="../../../assets/img/log_beispiel_spss_1.png" alt="beispiel spss 1"> <br>

      Wichtig ist an dieser Stelle, wie eigentlich immer, das Skalenniveau. Alle
      unabhängige Variablen sind metrisch, mit Ausnahme des Geschlechts. Dieses ist hier
      Dummy-codiert (0-weiblich, 1-männlich). <br>


      Über Analysieren->Regression->Binär Logistisch können wir unser Modell bauen.
      Wichtig sind an dieser Stelle auch die Tests der Voraussetzungen. In den Menüs
      „Speichern“ und „Optionen“ können wir alles einstellen.
      <br><br>
      Optional können wir uns das Modell auch selbst in der Syntax programmieren: <br><br>

      <div class="syntax" style="text-align: left; font-weight: bold;">
        <span style="color: rgb(0, 132, 255)">LOGISTIC REGRESSION</span>
        <span style="color: rgb(194, 0, 0)"> VARIABLES</span>
        Bestanden <br>

        <span style="color: rgb(0, 128, 28)">/METHOD=</span>
        <span style="color: rgb(194, 0, 0)">ENTER</span>
        Stunden_gelernt Versuch Geschlecht
        <br>

        <span style="color: rgb(0, 128, 28)">/SAVE=</span>
        <span style="color: rgb(194, 0, 0)">COOK LRESID</span>
        <br>

        <span style="color: rgb(0, 128, 28)">/CLASSPLOT</span>
        <br>

        <span style="color: rgb(0, 128, 28)">/PRINT=</span>
        <span style="color: rgb(194, 0, 0)">ITER</span>(1)
        <span style="color: rgb(194, 0, 0)"> CI</span>(95)
        <br>

        <span style="color: rgb(0, 128, 28)">/CRITERIA=</span>
        <span style="color: rgb(194, 0, 0)">PIN</span>(0.05)
        <span style="color: rgb(194, 0, 0)">POUT</span>(0.10)
        <span style="color: rgb(194, 0, 0)">ITERATE</span>(20)
        <span style="color: rgb(194, 0, 0)">CUT</span>(0.5)
      </div>
      <br><br>

      Als Resultat zeigt sich folgendes Ergebnis:
      <br>

      <img src="../../../assets/img/omnibustest.png" alt="omnibustest">
      <br>
      Beispiel in R
      Die Funktion „GLM“ ist in R vergleichsweise einfach aufgebaut. Nachdem wir unseren
      Datensatz aus SPSS eingelesen haben, können wir hier ganz einfach unser Modell
      bauen. Wenn wir den Datensatz df in der Funktion definiert haben, können wir an
      erster Stelle die abhängige Variable definieren und dann die unabhängigen. Zudem
      werden separat die Odds Ration und Pseudo-R² Statistiken berechnet
      (Varianzaufklärung)
      <br><br>
      <iframe width='100%' height='800'
        src='https://rdrr.io/snippets/embed/?code=%23Datensatz%20erstellen%0A%23%23Variablen%20erstellen%0A%0ABestanden%3C-c(1%2C1%2C1%2C1%2C1%2C1%2C0%2C0%2C0%2C1%2C0%2C0%2C0%2C1%2C0%2C1%2C1%2C0%2C1%2C1%2C1%2C1%2C0%2C0%2C0%2C1%2C0%2C1%2C1%2C1%2C0%2C1%2C%0A1%2C0%2C1%2C1%2C1%2C1%2C0%2C0%2C0%2C1%2C0%2C1%2C1%2C0%2C0%2C1%2C0%2C0%2C1%2C1%2C1%2C1%2C0%2C1%2C0%2C1%2C0%2C1%2C1%2C1%2C0%2C1)%0AStunden_gelernt%3C-c(21.00%2C18.00%2C19.00%2C23.00%2C25.00%2C30.00%2C4.00%2C16.00%2C10.00%2C25.00%2C5.00%2C10.00%2C19.00%2C28.00%2C10.00%2C27.00%2C21.00%2C18.00%2C19.00%2C23.00%2C25.00%2C30.00%2C4.00%2C16.00%2C10.00%2C25.00%2C5.00%2C10.00%2C19.00%2C28.00%2C10.00%2C27.00%2C21.00%2C18.00%2C19.00%2C23.00%2C25.00%2C30.00%2C4.00%2C16.00%2C10.00%2C25.00%2C5.00%2C10.00%2C19.00%2C28.00%2C10.00%2C27.00%2C21.00%2C18.00%2C19.00%2C23.00%2C25.00%2C30.00%2C4.00%2C16.00%2C10.00%2C25.00%2C5.00%2C10.00%2C19.00%2C28.00%2C10.00%2C27.00)%0AVersuch%3C-c(1.00%2C1.00%2C2.00%2C2.00%2C1.00%2C1.00%2C3.00%2C1.00%2C1.00%2C3.00%2C2.00%2C1.00%2C3.00%2C3.00%2C2.00%2C1.00%2C1.00%2C1.00%2C2.00%2C2.00%2C1.00%2C1.00%2C3.00%2C1.00%2C1.00%2C3.00%2C2.00%2C1.00%2C3.00%2C3.00%2C2.00%2C1.00%2C1.00%2C1.00%2C2.00%2C2.00%2C1.00%2C1.00%2C3.00%2C1.00%2C1.00%2C3.00%2C2.00%2C1.00%2C3.00%2C3.00%2C2.00%2C1.00%2C1.00%2C1.00%2C2.00%2C2.00%2C1.00%2C1.00%2C3.00%2C1.00%2C1.00%2C3.00%2C2.00%2C1.00%2C3.00%2C3.00%2C2.00%2C1.00)%0AGeschlecht%3C-c(.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00%2C1.00)%0A%0A%23%23Zu%20einem%20Datensatz%20zusammenf%C3%BChren%0A%0Adf%3C-data.frame(Bestanden%2CStunden_gelernt%2CVersuch%2CGeschlecht)%0A%0A%23%23%23Logistic%20Regression%0A%0AlogMod%20%3C-%20glm(Bestanden~Stunden_gelernt%20%2B%20Versuch%20%2B%20Geschlecht%2C%20data%3Ddf)%20%0Asummary(logMod%20)%0A%0A%23%23%23Odds%20Ratio%0A%0Aexp(cbind(coef(logMod%20)%2C%20confint(logMod%20)))%20%0A%0A%23%23%23Pseudo%20R%C2%B2%20%0A%0Alibrary(rcompanion%20)%0Anagelkerke(logMod%20%2C%20null%20%3D%20NULL%2C%20restrictNobs%20%3D%20FALSE)%0A'
        frameborder='0'></iframe>
      <br>
      <h2>Interpretation </h2>
      <p>
        Zu allererst sollten wir die Modellzusammenfassung interpretieren (Block 1). In SPSS ist
        diese unter Omnibus Test aufgeführt. An dieser Stelle können wir sehen, dass unser
        Modell eindeutig signifikant wird (χ²(3)=37.815, p&lt;.001, R²=.602). Wir benutzen das Nagelkerke-R². Das heißt,
        dass 60.2 % der Varianz des Bestehens durch die in das Modell aufgenommen Variablen erklärt werden können, was
        für einen sehr guten Fit spricht.
      </p>
      <p>
        Was sagen uns nun die einzelnen Koeffizienten? Im Kontext der logistischen Funktion
        nicht viel. Eine Interpretation ist an dieser Stelle nicht zielführend. Lediglich eine
        Überprüfung der Vorzeichen ergibt hier Sinn, da wir sehen ob ein Anstieg der
        unabhängigen Variable um eine Einheit die Chance für Y=1 vergrößert oder verringert.
      </p>
      <p>
        Viel entscheidender sind jedoch die Odds Ratios bzw. die Quotenverhältnisse. Ein
        Quotenverhältnis von 1:1 würde bedeuten, dass ein Anstieg der unabhängigen Variable zu
        einem Verhältnis von nicht-bestanden : bestanden von 1:1 führt. Die Chancen bleiben
        also gleich, die Variable hat keinen Einfluss. Eine Odds Ratio >1 bedeutet also ein
        Anstieg der Chance, eine Odds Ratio &lt; 1 eine Reduktion. Man kann auch einfach den Wert 1 von der OR abziehen
        und
        erhält die Veränderung in Prozent. Eine OR von 0.45 würde beispielsweise eine Verringerung der Chance für
        Bestanden um 55% bedeuten (1-0.45).
      </p>
      <p>
        In unserem Beispiel üben lediglich die gelernten Stunden einen
        signifikanten Einfluss aus (b=.303, p&lt;.001, OR=1.353, KI[1.144,1.601]). Steigt sie Zahl der gelernten Stunden
        um eine Einheit (eine Stunde), so steigt die Chance zum Bestehen der Klausur um 35,3%. Warum haben die
        anderen Variablen aber eine höhere OR und sind dennoch nicht signifikant? Hier können wir einen Blick auf
        die Konfidenzintervalle werfen. Der Wert 1 (Chance 1:1, also das Nullmodell) wird immer eingeschlossen,
        außer bei den gelernten Stunden. Das spricht für eine sehr ungenaue Schätzung bezüglich des Geschlechts und
        des Versuchs.
      </p>
      <p>Wir erhalten als Modell also folgende nicht-lineare Gleichung:</p>
      <img src="../../../assets/img/log_gleichung_2.jpg" alt="logistische funktionsgleichung 2">
      <p>Fragen, Probleme, Anmerkungen? Dann schreib uns einfach und wir helfen dir sehr
        gerne weiter.</p>
      <div class="button" routerLink="/kostenloses-erstgepraech"><span>Kostenloses
          Erstgespräch</span>
      </div>
      <p>
        Dein Team von Hanseatic-Statistics
      </p>
      <div class="quellen">
        Quellen: <br>
        Bortz, J. & Döring, N. (2016). Forschungsmethoden und Evaluation für Human- und
        Sozialwissenschaftler. 5. Auflage. Heidelberg: Springer. <br>
        Backhaus, K., Erichson, B., Plinke, W. & Weiber, R. (2016). Multivariate
        Analysemethoden. Eine
        anwendungsorientierte Einführung. 14. Auflage. Berlin: Springer. <br>
        Hirsig, R. (2006a). Statistische Methoden in den Sozialwissenschaften. Eine
        Einführung im
        Hinblick auf computergestützte Datenanalysen mit SPSS. Band I. 5. Auflage.
        Zürich: Seismo.
      </div>
    </main>
  </div>
</div>
